import {
  __privateAdd,
  __privateGet,
  __privateMethod,
  __privateSet,
  errorThrower
} from "./chunk-RPBFXD3D.js";

// src/polyfills.ts
if (typeof window !== "undefined" && !window.global)
  window.global = typeof globalThis === "undefined" ? window : globalThis;

// src/index.ts
import { setClerkJsLoadingErrorPackageName } from "@clerk/shared/loadClerkJsScript";

// src/components/SignInButton.vue
import { defineComponent as _defineComponent } from "vue";

// src/composables/usePolymorphicRef.ts
import { ref } from "vue";
function usePolymorphicRef() {
  const node = ref(null);
  const setRef = (value) => node.value = value;
  return {
    node,
    setRef
  };
}

// src/composables/useClerkProvider.ts
import { inject } from "vue";

// src/keys.ts
var VueClerkInjectionKey = "$$_clerk";

// src/composables/useClerkProvider.ts
function useClerkProvider() {
  const ctx = inject(VueClerkInjectionKey);
  if (!ctx) {
    throw new Error(
      "This composable can only be used when the Vue Clerk plugin is installed. Learn more: https://vue-clerk.com/plugin"
    );
  }
  return ctx;
}

// src/composables/useClerk.ts
function useClerk() {
  const { clerk } = useClerkProvider();
  return clerk;
}

// src/components/SignInButton.vue
import { normalizeProps as _normalizeProps, renderSlot as _renderSlot, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

// unplugin-vue: /plugin-vue/export-helper
var export_helper_default = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

// src/components/SignInButton.vue
var _sfc_main = /* @__PURE__ */ _defineComponent({
  __name: "SignInButton",
  props: {
    fallbackRedirectUrl: { type: [String, null], required: false },
    forceRedirectUrl: { type: [String, null], required: false },
    signUpForceRedirectUrl: { type: [String, null], required: false },
    signUpFallbackRedirectUrl: { type: [String, null], required: false },
    mode: { type: String, required: false },
    asChild: { type: Boolean, required: false, skipCheck: true, default: void 0 }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const { node, setRef } = usePolymorphicRef();
    const clerk = useClerk();
    function clickHandler() {
      const { mode, ...opts } = props;
      if (mode === "modal")
        return clerk.openSignIn(opts);
      return clerk.redirectToSignIn({
        ...opts,
        signInFallbackRedirectUrl: props.fallbackRedirectUrl,
        signInForceRedirectUrl: props.forceRedirectUrl
      });
    }
    const __returned__ = { props, node, setRef, clerk, clickHandler };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.asChild ? _renderSlot(_ctx.$slots, "default", _normalizeProps(_mergeProps({ key: 0 }, { ..._ctx.$attrs, onClick: $setup.clickHandler, ref: $setup.setRef }))) : (_openBlock(), _createElementBlock(
    "button",
    _mergeProps({
      key: 1,
      ref: "node",
      "data-testid": "sign-in-btn"
    }, _ctx.$attrs, { onClick: $setup.clickHandler }),
    [
      _renderSlot(_ctx.$slots, "default", { handler: $setup.clickHandler }, () => [
        _cache[0] || (_cache[0] = _createTextVNode(" Sign in "))
      ])
    ],
    16
    /* FULL_PROPS */
  ));
}
var SignInButton_default = /* @__PURE__ */ export_helper_default(_sfc_main, [["render", _sfc_render], ["__file", "/home/runner/work/vue-clerk/vue-clerk/packages/vue-clerk/src/components/SignInButton.vue"]]);

// src/components/SignUpButton.vue
import { defineComponent as _defineComponent2 } from "vue";
import { normalizeProps as _normalizeProps2, renderSlot as _renderSlot2, mergeProps as _mergeProps2, createTextVNode as _createTextVNode2, openBlock as _openBlock2, createElementBlock as _createElementBlock2 } from "vue";
var _sfc_main2 = /* @__PURE__ */ _defineComponent2({
  __name: "SignUpButton",
  props: {
    unsafeMetadata: { type: null, required: false },
    fallbackRedirectUrl: { type: [String, null], required: false },
    forceRedirectUrl: { type: [String, null], required: false },
    signInForceRedirectUrl: { type: [String, null], required: false },
    signInFallbackRedirectUrl: { type: [String, null], required: false },
    mode: { type: String, required: false },
    asChild: { type: Boolean, required: false, skipCheck: true, default: void 0 }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const clerk = useClerk();
    const { node, setRef } = usePolymorphicRef();
    function clickHandler() {
      const { mode, ...opts } = props;
      if (mode === "modal")
        return clerk.openSignUp(opts);
      return clerk.redirectToSignUp({
        ...opts,
        signUpFallbackRedirectUrl: props.fallbackRedirectUrl,
        signUpForceRedirectUrl: props.forceRedirectUrl
      });
    }
    const __returned__ = { props, clerk, node, setRef, clickHandler };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render2(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.asChild ? _renderSlot2(_ctx.$slots, "default", _normalizeProps2(_mergeProps2({ key: 0 }, { ..._ctx.$attrs, onClick: $setup.clickHandler, ref: $setup.setRef }))) : (_openBlock2(), _createElementBlock2(
    "button",
    _mergeProps2({
      key: 1,
      ref: "node",
      "data-testid": "sign-up-btn"
    }, _ctx.$attrs, { onClick: $setup.clickHandler }),
    [
      _renderSlot2(_ctx.$slots, "default", { handler: $setup.clickHandler }, () => [
        _cache[0] || (_cache[0] = _createTextVNode2(" Sign up "))
      ])
    ],
    16
    /* FULL_PROPS */
  ));
}
var SignUpButton_default = /* @__PURE__ */ export_helper_default(_sfc_main2, [["render", _sfc_render2], ["__file", "/home/runner/work/vue-clerk/vue-clerk/packages/vue-clerk/src/components/SignUpButton.vue"]]);

// src/components/SignOutButton.vue
import { defineComponent as _defineComponent3 } from "vue";
import { normalizeProps as _normalizeProps3, renderSlot as _renderSlot3, mergeProps as _mergeProps3, createTextVNode as _createTextVNode3, openBlock as _openBlock3, createElementBlock as _createElementBlock3 } from "vue";
var _sfc_main3 = /* @__PURE__ */ _defineComponent3({
  __name: "SignOutButton",
  props: {
    signOutOptions: { type: Object, required: false },
    sessionId: { type: String, required: false },
    redirectUrl: { type: String, required: false },
    asChild: { type: Boolean, required: false, skipCheck: true, default: void 0 }
  },
  emits: ["signOut"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props = __props;
    const emit = __emit;
    const { node, setRef } = usePolymorphicRef();
    const clerk = useClerk();
    function signOutCallback() {
      emit("signOut");
    }
    function clickHandler() {
      var _a, _b, _c, _d;
      const signOutOptions = {
        redirectUrl: (_b = (_a = props.signOutOptions) == null ? void 0 : _a.redirectUrl) != null ? _b : props.redirectUrl,
        sessionId: (_d = (_c = props.signOutOptions) == null ? void 0 : _c.sessionId) != null ? _d : props.sessionId
      };
      return clerk.signOut(signOutCallback, signOutOptions);
    }
    const __returned__ = { props, emit, node, setRef, clerk, signOutCallback, clickHandler };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render3(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.asChild ? _renderSlot3(_ctx.$slots, "default", _normalizeProps3(_mergeProps3({ key: 0 }, { ..._ctx.$attrs, onClick: $setup.clickHandler, ref: $setup.setRef }))) : (_openBlock3(), _createElementBlock3(
    "button",
    _mergeProps3({
      key: 1,
      ref: "node",
      "data-testid": "sign-out-btn"
    }, _ctx.$attrs, { onClick: $setup.clickHandler }),
    [
      _renderSlot3(_ctx.$slots, "default", { handler: $setup.clickHandler }, () => [
        _cache[0] || (_cache[0] = _createTextVNode3(" Sign out "))
      ])
    ],
    16
    /* FULL_PROPS */
  ));
}
var SignOutButton_default = /* @__PURE__ */ export_helper_default(_sfc_main3, [["render", _sfc_render3], ["__file", "/home/runner/work/vue-clerk/vue-clerk/packages/vue-clerk/src/components/SignOutButton.vue"]]);

// src/components/SignInWithMetamaskButton.vue
import { defineComponent as _defineComponent4 } from "vue";
import { normalizeProps as _normalizeProps4, renderSlot as _renderSlot4, mergeProps as _mergeProps4, createTextVNode as _createTextVNode4, openBlock as _openBlock4, createElementBlock as _createElementBlock4 } from "vue";
var _sfc_main4 = /* @__PURE__ */ _defineComponent4({
  __name: "SignInWithMetamaskButton",
  props: {
    redirectUrl: { type: [String, null], required: false },
    asChild: { type: Boolean, required: false, skipCheck: true, default: void 0 }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props = __props;
    const { node, setRef } = usePolymorphicRef();
    const clerk = useClerk();
    function clickHandler() {
      void clerk.authenticateWithMetamask({ redirectUrl: props.redirectUrl || void 0 });
    }
    const __returned__ = { props, node, setRef, clerk, clickHandler };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render4(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.asChild ? _renderSlot4(_ctx.$slots, "default", _normalizeProps4(_mergeProps4({ key: 0 }, { ..._ctx.$attrs, onClick: $setup.clickHandler, ref: $setup.setRef }))) : (_openBlock4(), _createElementBlock4(
    "button",
    _mergeProps4({
      key: 1,
      ref: "node",
      "data-testid": "sign-in-btn"
    }, _ctx.$attrs, { onClick: $setup.clickHandler }),
    [
      _renderSlot4(_ctx.$slots, "default", { handler: $setup.clickHandler }, () => [
        _cache[0] || (_cache[0] = _createTextVNode4(" Sign in with Metamask "))
      ])
    ],
    16
    /* FULL_PROPS */
  ));
}
var SignInWithMetamaskButton_default = /* @__PURE__ */ export_helper_default(_sfc_main4, [["render", _sfc_render4], ["__file", "/home/runner/work/vue-clerk/vue-clerk/packages/vue-clerk/src/components/SignInWithMetamaskButton.vue"]]);

// src/components/WithUser.vue
import { defineComponent as _defineComponent5 } from "vue";
import { reactive } from "vue";

// src/composables/useUser.ts
import { computed as computed2 } from "vue";

// src/utils/isConstructor.ts
function isConstructor(f) {
  return typeof f === "function";
}

// src/utils/toComputedRefs.ts
import { computed } from "vue";
function toComputedRefs(objectRef) {
  const result = {};
  for (const key in objectRef.value)
    result[key] = computed(() => objectRef.value[key]);
  return result;
}

// src/composables/useUser.ts
function useUser() {
  const { userCtx } = useClerkProvider();
  const result = computed2(() => {
    if (userCtx.value === void 0)
      return { isLoaded: false, isSignedIn: void 0, user: void 0 };
    if (userCtx.value === null)
      return { isLoaded: true, isSignedIn: false, user: null };
    return { isLoaded: true, isSignedIn: true, user: userCtx.value };
  });
  return toComputedRefs(result);
}

// src/components/WithUser.vue
import { normalizeProps as _normalizeProps5, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot5 } from "vue";
var _sfc_main5 = /* @__PURE__ */ _defineComponent5({
  __name: "WithUser",
  setup(__props, { expose: __expose }) {
    __expose();
    const props = reactive(useUser());
    const __returned__ = { props };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render5(_ctx, _cache, $props, $setup, $data, $options) {
  return _renderSlot5(_ctx.$slots, "default", _normalizeProps5(_guardReactiveProps($setup.props)));
}
var WithUser_default = /* @__PURE__ */ export_helper_default(_sfc_main5, [["render", _sfc_render5], ["__file", "/home/runner/work/vue-clerk/vue-clerk/packages/vue-clerk/src/components/WithUser.vue"]]);

// src/components/WithClerk.vue
import { defineComponent as _defineComponent6 } from "vue";
import { normalizeProps as _normalizeProps6, guardReactiveProps as _guardReactiveProps2, renderSlot as _renderSlot6 } from "vue";
var _sfc_main6 = /* @__PURE__ */ _defineComponent6({
  __name: "WithClerk",
  setup(__props, { expose: __expose }) {
    __expose();
    const clerk = useClerk();
    const __returned__ = { clerk };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render6(_ctx, _cache, $props, $setup, $data, $options) {
  return _renderSlot6(_ctx.$slots, "default", _normalizeProps6(_guardReactiveProps2($setup.clerk)));
}
var WithClerk_default = /* @__PURE__ */ export_helper_default(_sfc_main6, [["render", _sfc_render6], ["__file", "/home/runner/work/vue-clerk/vue-clerk/packages/vue-clerk/src/components/WithClerk.vue"]]);

// src/components/WithSession.vue
import { defineComponent as _defineComponent7 } from "vue";
import { reactive as reactive2 } from "vue";

// src/composables/useSession.ts
import { computed as computed3 } from "vue";
function useSession() {
  const { sessionCtx } = useClerkProvider();
  const result = computed3(() => {
    if (sessionCtx.value === void 0)
      return { isLoaded: false, isSignedIn: void 0, session: void 0 };
    if (sessionCtx.value === null)
      return { isLoaded: true, isSignedIn: false, session: null };
    return { isLoaded: true, isSignedIn: true, session: sessionCtx.value };
  });
  return toComputedRefs(result);
}

// src/components/WithSession.vue
import { normalizeProps as _normalizeProps7, guardReactiveProps as _guardReactiveProps3, renderSlot as _renderSlot7 } from "vue";
var _sfc_main7 = /* @__PURE__ */ _defineComponent7({
  __name: "WithSession",
  setup(__props, { expose: __expose }) {
    __expose();
    const props = reactive2(useSession());
    const __returned__ = { props };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render7(_ctx, _cache, $props, $setup, $data, $options) {
  return _renderSlot7(_ctx.$slots, "default", _normalizeProps7(_guardReactiveProps3($setup.props)));
}
var WithSession_default = /* @__PURE__ */ export_helper_default(_sfc_main7, [["render", _sfc_render7], ["__file", "/home/runner/work/vue-clerk/vue-clerk/packages/vue-clerk/src/components/WithSession.vue"]]);

// src/composables/useAuth.ts
import { computed as computed4 } from "vue";

// src/errors/messages.ts
var invalidStateError = "Invalid state. Feel free to submit a bug or reach out to support here: https://clerk.com/support";
var unsupportedNonBrowserDomainOrProxyUrlFunction = "Unsupported usage of isSatellite, domain or proxyUrl. The usage of isSatellite, domain or proxyUrl as function is not supported in non-browser environments.";
var useAuthHasRequiresRoleOrPermission = 'Missing parameters. `has` from `useAuth` requires a permission or role key to be passed. Example usage: `has({permission: "org:posts:edit"`';

// src/composables/useAuth.ts
function clerkLoaded(clerk) {
  return new Promise((resolve) => {
    if (clerk.loaded)
      resolve();
    clerk.addOnLoaded(() => resolve());
  });
}
function createGetToken(clerk) {
  return async (options) => {
    await clerkLoaded(clerk);
    if (!clerk.session)
      return null;
    return clerk.session.getToken(options);
  };
}
function createSignOut(clerk) {
  return async (...args) => {
    await clerkLoaded(clerk);
    return clerk.signOut(...args);
  };
}
function useAuth() {
  const { clerk, authCtx } = useClerkProvider();
  const getToken = createGetToken(clerk);
  const signOut = createSignOut(clerk);
  const result = computed4(() => {
    const { sessionId, userId, actor, orgId, orgRole, orgSlug, orgPermissions } = authCtx.value;
    const has = (params) => {
      if (!(params == null ? void 0 : params.permission) && !(params == null ? void 0 : params.role))
        throw new Error(useAuthHasRequiresRoleOrPermission);
      if (!orgId || !userId || !orgRole || !orgPermissions)
        return false;
      if (params.permission)
        return orgPermissions.includes(params.permission);
      if (params.role)
        return orgRole === params.role;
      return false;
    };
    if (sessionId === void 0 && userId === void 0) {
      return {
        isLoaded: false,
        isSignedIn: void 0,
        sessionId,
        userId,
        actor: void 0,
        orgId: void 0,
        orgRole: void 0,
        orgSlug: void 0,
        has: void 0,
        signOut,
        getToken
      };
    }
    if (sessionId === null && userId === null) {
      return {
        isLoaded: true,
        isSignedIn: false,
        sessionId,
        userId,
        actor: null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: () => false,
        signOut,
        getToken
      };
    }
    if (!!sessionId && !!userId && !!orgId && !!orgRole) {
      return {
        isLoaded: true,
        isSignedIn: true,
        sessionId,
        userId,
        actor: actor || null,
        orgId,
        orgRole,
        orgSlug: orgSlug || null,
        has,
        signOut,
        getToken
      };
    }
    if (!!sessionId && !!userId && !orgId) {
      return {
        isLoaded: true,
        isSignedIn: true,
        sessionId,
        userId,
        actor: actor || null,
        orgId: null,
        orgRole: null,
        orgSlug: null,
        has: () => false,
        signOut,
        getToken
      };
    }
    throw new Error(invalidStateError);
  });
  return toComputedRefs(result);
}

// src/composables/useSignIn.ts
import { computed as computed5 } from "vue";
import { eventMethodCalled } from "@clerk/shared/telemetry";
function useSignIn() {
  var _a;
  const { clerk, clientCtx } = useClerkProvider();
  (_a = clerk.telemetry) == null ? void 0 : _a.record(eventMethodCalled("useSignIn"));
  const result = computed5(() => {
    if (!clientCtx.value)
      return { isLoaded: false, signIn: void 0, setActive: void 0 };
    return {
      isLoaded: true,
      signIn: clientCtx.value.signIn,
      setActive: clerk.setActive
    };
  });
  return toComputedRefs(result);
}

// src/composables/useSignUp.ts
import { computed as computed6 } from "vue";
import { eventMethodCalled as eventMethodCalled2 } from "@clerk/shared/telemetry";
function useSignUp() {
  var _a;
  const { clerk, clientCtx } = useClerkProvider();
  (_a = clerk.telemetry) == null ? void 0 : _a.record(eventMethodCalled2("useSignUp"));
  const result = computed6(() => {
    if (!clientCtx.value)
      return { isLoaded: false, signUp: void 0, setActive: void 0 };
    return {
      isLoaded: true,
      signUp: clientCtx.value.signUp,
      setActive: clerk.setActive
    };
  });
  return toComputedRefs(result);
}

// src/composables/useSessionList.ts
import { computed as computed7 } from "vue";
function useSessionList() {
  const { clerk, clientCtx } = useClerkProvider();
  const result = computed7(() => {
    if (!clientCtx.value)
      return { isLoaded: false, sessions: void 0, setActive: void 0 };
    return {
      isLoaded: true,
      sessions: clientCtx.value.sessions,
      setActive: clerk.setActive
    };
  });
  return toComputedRefs(result);
}

// src/composables/useOrganization.ts
import { computed as computed8 } from "vue";
function useOrganization() {
  const { isClerkLoaded, organizationCtx } = useClerkProvider();
  const { session } = useSession();
  const result = computed8(() => {
    if (organizationCtx.value === void 0)
      return { isLoaded: false, organization: void 0, membership: void 0 };
    if (organizationCtx.value === null)
      return { isLoaded: true, organization: null, membership: null };
    if (!isClerkLoaded.value) {
      return {
        isLoaded: true,
        organization: organizationCtx.value,
        membership: void 0
      };
    }
    return {
      isLoaded: isClerkLoaded.value,
      organization: organizationCtx.value,
      membership: getCurrentOrganizationMembership(
        session.value.user.organizationMemberships,
        organizationCtx.value.id
      )
    };
  });
  return toComputedRefs(result);
}
function getCurrentOrganizationMembership(organizationMemberships, activeOrganizationId) {
  return organizationMemberships.find(
    (organizationMembership) => organizationMembership.organization.id === activeOrganizationId
  );
}

// src/provideClerkToVueApp.ts
import { computed as computed9, ref as ref2, shallowRef } from "vue";
import { isPublishableKey } from "@clerk/shared/keys";
import { deriveState } from "@clerk/shared/deriveState";

// src/isomorphicClerk.ts
import { inBrowser } from "@clerk/shared/browser";
import { handleValueOrFn } from "@clerk/shared/handleValueOrFn";
import { loadClerkJsScript } from "@clerk/shared/loadClerkJsScript";
var SDK_METADATA = {
  name: "vue-clerk",
  version: "0.6.19",
  environment: "production"
};
var _loaded, _domain, _proxyUrl, _publishableKey, _instance, _IsomorphicClerk_instances, waitForClerkJS_fn;
var _IsomorphicClerk = class _IsomorphicClerk {
  constructor(options) {
    __privateAdd(this, _IsomorphicClerk_instances);
    this.clerkjs = null;
    this.preopenOneTap = null;
    this.preopenUserVerification = null;
    this.preopenSignIn = null;
    this.preopenSignUp = null;
    this.preopenUserProfile = null;
    this.preopenOrganizationProfile = null;
    this.preopenCreateOrganization = null;
    this.premountSignInNodes = /* @__PURE__ */ new Map();
    this.premountSignUpNodes = /* @__PURE__ */ new Map();
    this.premountUserProfileNodes = /* @__PURE__ */ new Map();
    this.premountUserButtonNodes = /* @__PURE__ */ new Map();
    this.premountOrganizationProfileNodes = /* @__PURE__ */ new Map();
    this.premountCreateOrganizationNodes = /* @__PURE__ */ new Map();
    this.premountOrganizationSwitcherNodes = /* @__PURE__ */ new Map();
    this.premountOrganizationListNodes = /* @__PURE__ */ new Map();
    this.premountMethodCalls = /* @__PURE__ */ new Map();
    this.loadedListeners = [];
    /**
     * Stores pre-mount `addListener` calls to support multiple listeners and prevent overwrites.
     * This separate map ensures that both internal (clerkPlugin) and user-level
     * listeners are preserved during the pre-mount phase, avoiding race conditions.
     */
    this.premountAddListenerCalls = /* @__PURE__ */ new Map();
    __privateAdd(this, _loaded, false);
    __privateAdd(this, _domain);
    __privateAdd(this, _proxyUrl);
    __privateAdd(this, _publishableKey);
    this.buildSignInUrl = (opts) => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildSignInUrl(opts)) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildSignInUrl", callback);
      }
    };
    this.buildSignUpUrl = (opts) => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildSignUpUrl(opts)) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildSignUpUrl", callback);
      }
    };
    this.buildAfterSignInUrl = () => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignInUrl()) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildAfterSignInUrl", callback);
      }
    };
    this.buildAfterSignUpUrl = () => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignUpUrl()) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildAfterSignUpUrl", callback);
      }
    };
    this.buildAfterSignOutUrl = () => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterSignOutUrl()) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildAfterSignOutUrl", callback);
      }
    };
    this.buildAfterMultiSessionSingleSignOutUrl = () => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildAfterMultiSessionSingleSignOutUrl()) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildAfterMultiSessionSingleSignOutUrl", callback);
      }
    };
    this.buildUserProfileUrl = () => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildUserProfileUrl()) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildUserProfileUrl", callback);
      }
    };
    this.buildCreateOrganizationUrl = () => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildCreateOrganizationUrl()) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildCreateOrganizationUrl", callback);
      }
    };
    this.buildOrganizationProfileUrl = () => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildOrganizationProfileUrl()) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildOrganizationProfileUrl", callback);
      }
    };
    this.buildUrlWithAuth = (to) => {
      const callback = () => {
        var _a;
        return ((_a = this.clerkjs) == null ? void 0 : _a.buildUrlWithAuth(to)) || "";
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("buildUrlWithAuth", callback);
      }
    };
    this.handleUnauthenticated = () => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.handleUnauthenticated();
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        void callback();
      } else {
        this.premountMethodCalls.set("handleUnauthenticated", callback);
      }
    };
    this.addOnLoaded = (cb) => {
      this.loadedListeners.push(cb);
      if (this.loaded) {
        this.emitLoaded();
      }
    };
    this.emitLoaded = () => {
      this.loadedListeners.forEach((cb) => cb());
      this.loadedListeners = [];
    };
    this.hydrateClerkJS = (clerkjs) => {
      if (!clerkjs) {
        throw new Error("Failed to hydrate latest Clerk JS");
      }
      this.clerkjs = clerkjs;
      this.premountMethodCalls.forEach((cb) => cb());
      this.premountAddListenerCalls.forEach((value, listener) => {
        value.nativeUnsubscribe = clerkjs.addListener(listener);
      });
      if (this.preopenSignIn !== null) {
        clerkjs.openSignIn(this.preopenSignIn);
      }
      if (this.preopenSignUp !== null) {
        clerkjs.openSignUp(this.preopenSignUp);
      }
      if (this.preopenUserProfile !== null) {
        clerkjs.openUserProfile(this.preopenUserProfile);
      }
      if (this.preopenUserVerification !== null) {
        clerkjs.__experimental_openUserVerification(this.preopenUserVerification);
      }
      if (this.preopenOneTap !== null) {
        clerkjs.openGoogleOneTap(this.preopenOneTap);
      }
      if (this.preopenOrganizationProfile !== null) {
        clerkjs.openOrganizationProfile(this.preopenOrganizationProfile);
      }
      if (this.preopenCreateOrganization !== null) {
        clerkjs.openCreateOrganization(this.preopenCreateOrganization);
      }
      this.premountSignInNodes.forEach((props, node) => {
        clerkjs.mountSignIn(node, props);
      });
      this.premountSignUpNodes.forEach((props, node) => {
        clerkjs.mountSignUp(node, props);
      });
      this.premountUserProfileNodes.forEach((props, node) => {
        clerkjs.mountUserProfile(node, props);
      });
      this.premountUserButtonNodes.forEach((props, node) => {
        clerkjs.mountUserButton(node, props);
      });
      this.premountOrganizationListNodes.forEach((props, node) => {
        clerkjs.mountOrganizationList(node, props);
      });
      __privateSet(this, _loaded, true);
      this.emitLoaded();
      return this.clerkjs;
    };
    this.__unstable__updateProps = async (props) => {
      const clerkjs = await __privateMethod(this, _IsomorphicClerk_instances, waitForClerkJS_fn).call(this);
      if (clerkjs && "__unstable__updateProps" in clerkjs) {
        return clerkjs.__unstable__updateProps(props);
      }
    };
    /**
     * `setActive` can be used to set the active session and/or organization.
     */
    this.setActive = ({ session, organization, beforeEmit }) => {
      if (this.clerkjs) {
        return this.clerkjs.setActive({ session, organization, beforeEmit });
      } else {
        return Promise.reject();
      }
    };
    this.openSignIn = (props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.openSignIn(props);
      } else {
        this.preopenSignIn = props;
      }
    };
    this.closeSignIn = () => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.closeSignIn();
      } else {
        this.preopenSignIn = null;
      }
    };
    this.__experimental_openUserVerification = (props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.__experimental_openUserVerification(props);
      } else {
        this.preopenUserVerification = props;
      }
    };
    this.__experimental_closeUserVerification = () => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.__experimental_closeUserVerification();
      } else {
        this.preopenUserVerification = null;
      }
    };
    this.openGoogleOneTap = (props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.openGoogleOneTap(props);
      } else {
        this.preopenOneTap = props;
      }
    };
    this.closeGoogleOneTap = () => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.closeGoogleOneTap();
      } else {
        this.preopenOneTap = null;
      }
    };
    this.openUserProfile = (props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.openUserProfile(props);
      } else {
        this.preopenUserProfile = props;
      }
    };
    this.closeUserProfile = () => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.closeUserProfile();
      } else {
        this.preopenUserProfile = null;
      }
    };
    this.openOrganizationProfile = (props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.openOrganizationProfile(props);
      } else {
        this.preopenOrganizationProfile = props;
      }
    };
    this.closeOrganizationProfile = () => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.closeOrganizationProfile();
      } else {
        this.preopenOrganizationProfile = null;
      }
    };
    this.openCreateOrganization = (props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.openCreateOrganization(props);
      } else {
        this.preopenCreateOrganization = props;
      }
    };
    this.closeCreateOrganization = () => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.closeCreateOrganization();
      } else {
        this.preopenCreateOrganization = null;
      }
    };
    this.openSignUp = (props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.openSignUp(props);
      } else {
        this.preopenSignUp = props;
      }
    };
    this.closeSignUp = () => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.closeSignUp();
      } else {
        this.preopenSignUp = null;
      }
    };
    this.mountSignIn = (node, props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.mountSignIn(node, props);
      } else {
        this.premountSignInNodes.set(node, props);
      }
    };
    this.unmountSignIn = (node) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.unmountSignIn(node);
      } else {
        this.premountSignInNodes.delete(node);
      }
    };
    this.mountSignUp = (node, props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.mountSignUp(node, props);
      } else {
        this.premountSignUpNodes.set(node, props);
      }
    };
    this.unmountSignUp = (node) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.unmountSignUp(node);
      } else {
        this.premountSignUpNodes.delete(node);
      }
    };
    this.mountUserProfile = (node, props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.mountUserProfile(node, props);
      } else {
        this.premountUserProfileNodes.set(node, props);
      }
    };
    this.unmountUserProfile = (node) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.unmountUserProfile(node);
      } else {
        this.premountUserProfileNodes.delete(node);
      }
    };
    this.mountOrganizationProfile = (node, props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.mountOrganizationProfile(node, props);
      } else {
        this.premountOrganizationProfileNodes.set(node, props);
      }
    };
    this.unmountOrganizationProfile = (node) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.unmountOrganizationProfile(node);
      } else {
        this.premountOrganizationProfileNodes.delete(node);
      }
    };
    this.mountCreateOrganization = (node, props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.mountCreateOrganization(node, props);
      } else {
        this.premountCreateOrganizationNodes.set(node, props);
      }
    };
    this.unmountCreateOrganization = (node) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.unmountCreateOrganization(node);
      } else {
        this.premountCreateOrganizationNodes.delete(node);
      }
    };
    this.mountOrganizationSwitcher = (node, props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.mountOrganizationSwitcher(node, props);
      } else {
        this.premountOrganizationSwitcherNodes.set(node, props);
      }
    };
    this.unmountOrganizationSwitcher = (node) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.unmountOrganizationSwitcher(node);
      } else {
        this.premountOrganizationSwitcherNodes.delete(node);
      }
    };
    this.mountOrganizationList = (node, props) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.mountOrganizationList(node, props);
      } else {
        this.premountOrganizationListNodes.set(node, props);
      }
    };
    this.unmountOrganizationList = (node) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.unmountOrganizationList(node);
      } else {
        this.premountOrganizationListNodes.delete(node);
      }
    };
    this.mountUserButton = (node, userButtonProps) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.mountUserButton(node, userButtonProps);
      } else {
        this.premountUserButtonNodes.set(node, userButtonProps);
      }
    };
    this.unmountUserButton = (node) => {
      if (this.clerkjs && __privateGet(this, _loaded)) {
        this.clerkjs.unmountUserButton(node);
      } else {
        this.premountUserButtonNodes.delete(node);
      }
    };
    this.addListener = (listener) => {
      if (this.clerkjs) {
        return this.clerkjs.addListener(listener);
      } else {
        const unsubscribe = () => {
          var _a;
          const item = this.premountAddListenerCalls.get(listener);
          if (item) {
            (_a = item.nativeUnsubscribe) == null ? void 0 : _a.call(item);
            this.premountAddListenerCalls.delete(listener);
          }
        };
        this.premountAddListenerCalls.set(listener, { unsubscribe, nativeUnsubscribe: void 0 });
        return unsubscribe;
      }
    };
    this.navigate = (to) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.navigate(to);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        void callback();
      } else {
        this.premountMethodCalls.set("navigate", callback);
      }
    };
    this.redirectWithAuth = async (...args) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectWithAuth(...args);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("redirectWithAuth", callback);
      }
    };
    this.redirectToSignIn = async (opts) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectToSignIn(opts);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("redirectToSignIn", callback);
      }
    };
    this.redirectToSignUp = async (opts) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectToSignUp(opts);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("redirectToSignUp", callback);
      }
    };
    this.redirectToUserProfile = async () => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectToUserProfile();
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("redirectToUserProfile", callback);
      }
    };
    this.redirectToAfterSignUp = () => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignUp();
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("redirectToAfterSignUp", callback);
      }
    };
    this.redirectToAfterSignIn = () => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignIn();
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        callback();
      } else {
        this.premountMethodCalls.set("redirectToAfterSignIn", callback);
      }
    };
    this.redirectToAfterSignOut = () => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectToAfterSignOut();
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        callback();
      } else {
        this.premountMethodCalls.set("redirectToAfterSignOut", callback);
      }
    };
    this.redirectToOrganizationProfile = async () => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectToOrganizationProfile();
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("redirectToOrganizationProfile", callback);
      }
    };
    this.redirectToCreateOrganization = async () => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.redirectToCreateOrganization();
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("redirectToCreateOrganization", callback);
      }
    };
    this.handleRedirectCallback = (params) => {
      var _a;
      const callback = () => {
        var _a2;
        return (_a2 = this.clerkjs) == null ? void 0 : _a2.handleRedirectCallback(params);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        void ((_a = callback()) == null ? void 0 : _a.catch(() => {
        }));
      } else {
        this.premountMethodCalls.set("handleRedirectCallback", callback);
      }
    };
    this.handleGoogleOneTapCallback = (signInOrUp, params) => {
      var _a;
      const callback = () => {
        var _a2;
        return (_a2 = this.clerkjs) == null ? void 0 : _a2.handleGoogleOneTapCallback(signInOrUp, params);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        void ((_a = callback()) == null ? void 0 : _a.catch(() => {
        }));
      } else {
        this.premountMethodCalls.set("handleGoogleOneTapCallback", callback);
      }
    };
    this.handleEmailLinkVerification = async (params) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.handleEmailLinkVerification(params);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("handleEmailLinkVerification", callback);
      }
    };
    this.authenticateWithMetamask = async (params) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithMetamask(params);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("authenticateWithMetamask", callback);
      }
    };
    this.authenticateWithCoinbaseWallet = async (params) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithCoinbaseWallet(params);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("authenticateWithCoinbaseWallet", callback);
      }
    };
    this.authenticateWithWeb3 = async (params) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.authenticateWithWeb3(params);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("authenticateWithWeb3", callback);
      }
    };
    this.authenticateWithGoogleOneTap = async (params) => {
      const clerkjs = await __privateMethod(this, _IsomorphicClerk_instances, waitForClerkJS_fn).call(this);
      return clerkjs.authenticateWithGoogleOneTap(params);
    };
    this.createOrganization = async (params) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.createOrganization(params);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("createOrganization", callback);
      }
    };
    this.getOrganization = async (organizationId) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.getOrganization(organizationId);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("getOrganization", callback);
      }
    };
    this.signOut = async (signOutCallbackOrOptions, options) => {
      const callback = () => {
        var _a;
        return (_a = this.clerkjs) == null ? void 0 : _a.signOut(signOutCallbackOrOptions, options);
      };
      if (this.clerkjs && __privateGet(this, _loaded)) {
        return callback();
      } else {
        this.premountMethodCalls.set("signOut", callback);
      }
    };
    const { Clerk = null, publishableKey } = options || {};
    __privateSet(this, _publishableKey, publishableKey);
    __privateSet(this, _proxyUrl, options == null ? void 0 : options.proxyUrl);
    __privateSet(this, _domain, options == null ? void 0 : options.domain);
    this.options = options;
    this.Clerk = Clerk;
    this.mode = inBrowser() ? "browser" : "server";
    if (!this.options.sdkMetadata) {
      this.options.sdkMetadata = SDK_METADATA;
    }
    void this.loadClerkJS();
  }
  get publishableKey() {
    return __privateGet(this, _publishableKey);
  }
  get loaded() {
    return __privateGet(this, _loaded);
  }
  static getOrCreateInstance(options) {
    if (!inBrowser() || !__privateGet(this, _instance) || options.Clerk && __privateGet(this, _instance).Clerk !== options.Clerk) {
      __privateSet(this, _instance, new _IsomorphicClerk(options));
    }
    return __privateGet(this, _instance);
  }
  static clearInstance() {
    __privateSet(this, _instance, null);
  }
  get domain() {
    if (typeof window !== "undefined" && window.location) {
      return handleValueOrFn(__privateGet(this, _domain), new URL(window.location.href), "");
    }
    if (typeof __privateGet(this, _domain) === "function") {
      return errorThrower.throw(unsupportedNonBrowserDomainOrProxyUrlFunction);
    }
    return __privateGet(this, _domain) || "";
  }
  get proxyUrl() {
    if (typeof window !== "undefined" && window.location) {
      return handleValueOrFn(__privateGet(this, _proxyUrl), new URL(window.location.href), "");
    }
    if (typeof __privateGet(this, _proxyUrl) === "function") {
      return errorThrower.throw(unsupportedNonBrowserDomainOrProxyUrlFunction);
    }
    return __privateGet(this, _proxyUrl) || "";
  }
  get sdkMetadata() {
    var _a;
    return ((_a = this.clerkjs) == null ? void 0 : _a.sdkMetadata) || this.options.sdkMetadata || void 0;
  }
  get instanceType() {
    var _a;
    return (_a = this.clerkjs) == null ? void 0 : _a.instanceType;
  }
  get frontendApi() {
    var _a;
    return ((_a = this.clerkjs) == null ? void 0 : _a.frontendApi) || "";
  }
  get isStandardBrowser() {
    var _a;
    return ((_a = this.clerkjs) == null ? void 0 : _a.isStandardBrowser) || this.options.standardBrowser || false;
  }
  get isSatellite() {
    if (typeof window !== "undefined" && window.location) {
      return handleValueOrFn(this.options.isSatellite, new URL(window.location.href), false);
    }
    if (typeof this.options.isSatellite === "function") {
      return errorThrower.throw(unsupportedNonBrowserDomainOrProxyUrlFunction);
    }
    return false;
  }
  async loadClerkJS() {
    var _a;
    if (this.mode !== "browser" || __privateGet(this, _loaded)) {
      return;
    }
    if (typeof window !== "undefined") {
      window.__clerk_publishable_key = __privateGet(this, _publishableKey);
      window.__clerk_proxy_url = this.proxyUrl;
      window.__clerk_domain = this.domain;
    }
    try {
      if (this.Clerk) {
        let c;
        if (isConstructor(this.Clerk)) {
          c = new this.Clerk(__privateGet(this, _publishableKey), {
            proxyUrl: this.proxyUrl,
            domain: this.domain
          });
          await c.load(this.options);
        } else {
          c = this.Clerk;
          if (!c.loaded) {
            await c.load(this.options);
          }
        }
        global.Clerk = c;
      } else {
        if (!global.Clerk) {
          await loadClerkJsScript({
            ...this.options,
            publishableKey: __privateGet(this, _publishableKey),
            proxyUrl: this.proxyUrl,
            domain: this.domain
          });
        }
        if (!global.Clerk) {
          throw new Error("Failed to download latest ClerkJS. Contact support@clerk.com.");
        }
        await global.Clerk.load(this.options);
      }
      if ((_a = global.Clerk) == null ? void 0 : _a.loaded) {
        return this.hydrateClerkJS(global.Clerk);
      }
    } catch (err) {
      const error = err;
      if (true) {
        console.error(error.stack || error.message || error);
      } else {
        throw err;
      }
    }
  }
  get version() {
    var _a;
    return (_a = this.clerkjs) == null ? void 0 : _a.version;
  }
  get client() {
    if (this.clerkjs) {
      return this.clerkjs.client;
    } else {
      return void 0;
    }
  }
  get session() {
    if (this.clerkjs) {
      return this.clerkjs.session;
    } else {
      return void 0;
    }
  }
  get user() {
    if (this.clerkjs) {
      return this.clerkjs.user;
    } else {
      return void 0;
    }
  }
  get organization() {
    if (this.clerkjs) {
      return this.clerkjs.organization;
    } else {
      return void 0;
    }
  }
  get telemetry() {
    if (this.clerkjs) {
      return this.clerkjs.telemetry;
    } else {
      return void 0;
    }
  }
  get __unstable__environment() {
    if (this.clerkjs) {
      return this.clerkjs.__unstable__environment;
    } else {
      return void 0;
    }
  }
  __unstable__setEnvironment(...args) {
    if (this.clerkjs && "__unstable__setEnvironment" in this.clerkjs) {
      this.clerkjs.__unstable__setEnvironment(args);
    } else {
      return void 0;
    }
  }
};
_loaded = new WeakMap();
_domain = new WeakMap();
_proxyUrl = new WeakMap();
_publishableKey = new WeakMap();
_instance = new WeakMap();
_IsomorphicClerk_instances = new WeakSet();
waitForClerkJS_fn = function() {
  return new Promise((resolve) => {
    this.addOnLoaded(() => resolve(this.clerkjs));
  });
};
__privateAdd(_IsomorphicClerk, _instance);
var IsomorphicClerk = _IsomorphicClerk;

// src/provideClerkToVueApp.ts
var initOptions;
function provideClerkToVueApp(app, options) {
  const { initialState, publishableKey, Clerk: userInitializedClerk } = options;
  if (!userInitializedClerk) {
    if (!publishableKey)
      errorThrower.throwMissingPublishableKeyError();
    else if (publishableKey && !isPublishableKey(publishableKey))
      errorThrower.throwInvalidPublishableKeyError({ key: publishableKey });
  }
  const isClerkLoaded = ref2(false);
  const clerk = IsomorphicClerk.getOrCreateInstance(options);
  const state = shallowRef({
    client: clerk.client,
    session: clerk.session,
    user: clerk.user,
    organization: clerk.organization
  });
  clerk.addListener((payload) => {
    state.value = payload;
  });
  clerk.addOnLoaded(() => {
    isClerkLoaded.value = true;
  });
  const derivedState = computed9(() => deriveState(isClerkLoaded.value, state.value, initialState));
  const authCtx = computed9(() => {
    const { sessionId, userId, orgId, actor, orgRole, orgSlug, orgPermissions } = derivedState.value;
    return { sessionId, userId, actor, orgId, orgRole, orgSlug, orgPermissions };
  });
  const clientCtx = computed9(() => state.value.client);
  const userCtx = computed9(() => derivedState.value.user);
  const sessionCtx = computed9(() => derivedState.value.session);
  const organizationCtx = computed9(() => derivedState.value.organization);
  app.config.globalProperties.$clerk = clerk;
  app.provide(VueClerkInjectionKey, {
    clerk,
    isClerkLoaded,
    authCtx,
    clientCtx,
    sessionCtx,
    userCtx,
    organizationCtx
  });
  return clerk;
}
function updateClerkOptions(options) {
  void window.Clerk.__unstable__updateProps({
    options: { ...initOptions, ...options },
    appearance: { ...initOptions == null ? void 0 : initOptions.appearance, ...options.appearance }
  });
}

// src/plugin.ts
var clerkPlugin = {
  install(app, options) {
    provideClerkToVueApp(app, options);
  }
};

// src/components/uiComponents.ts
import { defineComponent as defineComponent5, h as h4, ref as ref6, watchEffect as watchEffect4 } from "vue";

// src/components/UserButton.ts
import { Teleport, computed as computed10, defineComponent as defineComponent2, h, ref as ref3, watchEffect } from "vue";

// src/components/controlComponents.ts
import { defineComponent, onMounted } from "vue";
var SignedIn = defineComponent({
  setup(_props, { slots }) {
    const { userId } = useAuth();
    return () => {
      var _a;
      return userId.value ? (_a = slots.default) == null ? void 0 : _a.call(slots) : null;
    };
  }
});
var SignedOut = defineComponent({
  setup(_props, { slots }) {
    const { userId } = useAuth();
    return () => {
      var _a;
      return userId.value === null ? (_a = slots.default) == null ? void 0 : _a.call(slots) : null;
    };
  }
});
var ClerkLoaded = defineComponent({
  setup(_props, { slots }) {
    const { isClerkLoaded } = useClerkProvider();
    return () => {
      var _a;
      return isClerkLoaded.value ? (_a = slots.default) == null ? void 0 : _a.call(slots) : null;
    };
  }
});
var ClerkLoading = defineComponent({
  setup(_props, { slots }) {
    const { isClerkLoaded } = useClerkProvider();
    return () => {
      var _a;
      return !isClerkLoaded.value ? (_a = slots.default) == null ? void 0 : _a.call(slots) : null;
    };
  }
});
var RedirectToSignIn = defineComponent((props) => {
  var _a;
  const { sessionCtx, clientCtx } = useClerkProvider();
  const clerk = useClerk();
  const hasActiveSessions = ((_a = clientCtx.value) == null ? void 0 : _a.activeSessions) && clientCtx.value.activeSessions.length > 0;
  onMounted(() => {
    if (sessionCtx.value === null && hasActiveSessions)
      void clerk.redirectToAfterSignOut();
    else
      void clerk.redirectToSignIn(props);
  });
  return () => null;
});
Object.defineProperty(RedirectToSignIn, "props", {
  value: ["signInForceRedirectUrl", "signInFallbackRedirectUrl", "signUpForceRedirectUrl", "signUpFallbackRedirectUrl", "afterSignInUrl", "afterSignUpUrl", "redirectUrl"]
});
var RedirectToSignUp = defineComponent((props) => {
  const clerk = useClerk();
  onMounted(() => {
    void clerk.redirectToSignUp(props);
  });
  return () => null;
});
Object.defineProperty(RedirectToSignUp, "props", {
  value: ["signInForceRedirectUrl", "signInFallbackRedirectUrl", "signUpForceRedirectUrl", "signUpFallbackRedirectUrl", "afterSignInUrl", "afterSignUpUrl", "redirectUrl"]
});
var RedirectToUserProfile = defineComponent(() => {
  const clerk = useClerk();
  onMounted(() => {
    void clerk.redirectToUserProfile();
  });
  return () => null;
});
var RedirectToOrganizationProfile = defineComponent(() => {
  const clerk = useClerk();
  onMounted(() => {
    void clerk.redirectToOrganizationProfile();
  });
  return () => null;
});
var RedirectToCreateOrganization = defineComponent(() => {
  const clerk = useClerk();
  onMounted(() => {
    void clerk.redirectToCreateOrganization();
  });
  return () => null;
});
var AuthenticateWithRedirectCallback = defineComponent((props) => {
  const clerk = useClerk();
  onMounted(() => {
    void clerk.handleRedirectCallback(props);
  });
  return () => null;
});
Object.defineProperty(AuthenticateWithRedirectCallback, "props", {
  value: ["signInForceRedirectUrl", "signInFallbackRedirectUrl", "signUpForceRedirectUrl", "signUpFallbackRedirectUrl", "afterSignInUrl", "afterSignUpUrl", "redirectUrl", "signInUrl", "signUpUrl", "firstFactorUrl", "secondFactorUrl", "resetPasswordUrl", "continueSignUpUrl", "verifyEmailAddressUrl", "verifyPhoneNumberUrl", "transferable"]
});
var Protect = defineComponent((props, { slots }) => {
  const { isLoaded, has, userId } = useAuth();
  return () => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!isLoaded.value)
      return null;
    if (!userId.value)
      return (_a = slots.fallback) == null ? void 0 : _a.call(slots);
    if (typeof props.condition === "function") {
      if (props.condition(has.value))
        return (_b = slots.default) == null ? void 0 : _b.call(slots);
      return (_c = slots.fallback) == null ? void 0 : _c.call(slots);
    }
    if (props.role || props.permission) {
      if ((_d = has.value) == null ? void 0 : _d.call(has, props))
        return (_e = slots.default) == null ? void 0 : _e.call(slots);
      return (_f = slots.fallback) == null ? void 0 : _f.call(slots);
    }
    return (_g = slots.default) == null ? void 0 : _g.call(slots);
  };
});
Object.defineProperty(Protect, "props", {
  value: ["condition", "role", "permission"]
});

// src/components/UserButton.ts
var reorderItemsLabels = ["manageAccount", "signOut"];
var UserButtonRoot = defineComponent2((props, { slots }) => {
  var _a;
  const clerk = useClerk();
  const el = ref3(null);
  const teleportDestinationMap = ref3(/* @__PURE__ */ new Map());
  const customItemsNodes = (_a = slots.default) == null ? void 0 : _a.call(slots);
  const customMenuItemsAndPages = computed10(() => {
    const customMenuItems = [];
    const customPages = [];
    customItemsNodes == null ? void 0 : customItemsNodes.forEach((node) => {
      var _a2, _b, _c, _d;
      if (node.type.name === "UserButtonMenuItems") {
        node.children.default().forEach((menuItemNode) => {
          var _a3, _b2, _c2, _d2, _e;
          const isReorderItem = reorderItemsLabels.includes(menuItemNode.props.label);
          if (isReorderItem) {
            customMenuItems.push({
              label: menuItemNode.props.label
            });
            return;
          }
          const customMenuItem = {
            label: (_b2 = (_a3 = menuItemNode.props) == null ? void 0 : _a3.label) != null ? _b2 : "",
            mountIcon(el2) {
              teleportDestinationMap.value.set(el2, {
                to: el2,
                children: menuItemNode.children.labelIcon
              });
            },
            unmountIcon: (el2) => {
              if (el2) {
                teleportDestinationMap.value.delete(el2);
              }
            }
          };
          if ((_c2 = menuItemNode.props) == null ? void 0 : _c2.href) {
            customMenuItem.href = menuItemNode.props.href;
          } else if ((_d2 = menuItemNode.props) == null ? void 0 : _d2.onClick) {
            customMenuItem.onClick = menuItemNode.props.onClick;
          } else if ((_e = menuItemNode.props) == null ? void 0 : _e.open) {
            customMenuItem.open = menuItemNode.props.open;
          }
          customMenuItems.push(customMenuItem);
        });
      } else if (["UserButtonUserProfilePage", "UserButtonUserProfileLink"].includes(node.type.name)) {
        const customPage = {
          label: (_b = (_a2 = node.props) == null ? void 0 : _a2.label) != null ? _b : "",
          url: (_d = (_c = node.props) == null ? void 0 : _c.url) != null ? _d : "",
          mountIcon(el2) {
            teleportDestinationMap.value.set(el2, {
              to: el2,
              children: node.children.labelIcon
            });
          },
          unmountIcon: (el2) => {
            if (el2) {
              teleportDestinationMap.value.delete(el2);
            }
          }
        };
        if (node.type.name === "UserButtonUserProfilePage") {
          customPage.mount = (el2) => {
            teleportDestinationMap.value.set(el2, {
              to: el2,
              children: node.children.default
            });
          };
          customPage.unmount = (el2) => {
            if (el2) {
              teleportDestinationMap.value.delete(el2);
            }
          };
        }
        customPages.push(customPage);
      }
    });
    return {
      menuItems: customMenuItems,
      pages: customPages
    };
  });
  watchEffect((onInvalidate) => {
    if (el.value) {
      clerk.mountUserButton(el.value, {
        ...props,
        customMenuItems: customMenuItemsAndPages.value.menuItems,
        userProfileProps: {
          ...props.userProfileProps,
          customPages: customMenuItemsAndPages.value.pages
        }
      });
    }
    onInvalidate(() => {
      if (el.value)
        clerk.unmountUserButton(el.value);
    });
  });
  return () => h(ClerkLoaded, () => {
    var _a2;
    return [
      h("div", { ref: el }),
      ...(_a2 = Array.from(teleportDestinationMap.value.values()).map((item) => {
        return h(Teleport, { to: item.to }, item.children());
      })) != null ? _a2 : []
    ];
  });
});
Object.defineProperty(UserButtonRoot, "props", {
  value: ["userProfileUrl", "userProfileMode", "showName", "defaultOpen", "afterSignOutUrl", "afterMultiSessionSingleSignOutUrl", "signInUrl", "afterSwitchSessionUrl", "appearance", "userProfileProps", "customMenuItems"]
});
var UserButtonMenuItems = defineComponent2((_props, { slots }) => {
  return () => {
    var _a;
    return (_a = slots.default) == null ? void 0 : _a.call(slots);
  };
}, {
  name: "UserButtonMenuItems",
  inheritAttrs: false
});
var UserButtonLink = defineComponent2({
  inheritAttrs: false,
  name: "UserButtonLink",
  props: {
    label: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: true
    }
  },
  setup(_props, { slots }) {
    return () => {
      var _a;
      return (_a = slots.labelIcon) == null ? void 0 : _a.call(slots);
    };
  }
});
var UserButtonAction = defineComponent2(
  (_props, { slots }) => {
    return () => {
      var _a;
      return (_a = slots.labelIcon) == null ? void 0 : _a.call(slots);
    };
  }
);
Object.defineProperty(UserButtonAction, "props", {
  value: ["onClick", "open"]
});
var UserButtonUserProfilePage = defineComponent2({
  inheritAttrs: false,
  name: "UserButtonUserProfilePage",
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  setup(_props, { slots }) {
    return () => {
      var _a;
      return (_a = slots.labelIcon) == null ? void 0 : _a.call(slots);
    };
  }
});
var UserButtonUserProfileLink = defineComponent2({
  inheritAttrs: false,
  name: "UserButtonUserProfileLink",
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  setup(_props, { slots }) {
    return () => {
      var _a;
      return (_a = slots.labelIcon) == null ? void 0 : _a.call(slots);
    };
  }
});
var UserButton = Object.assign(UserButtonRoot, {
  MenuItems: UserButtonMenuItems,
  Link: UserButtonLink,
  Action: UserButtonAction,
  UserProfilePage: UserButtonUserProfilePage,
  UserProfileLink: UserButtonUserProfileLink
});

// src/components/OrganizationProfile.ts
import { Teleport as Teleport2, computed as computed11, defineComponent as defineComponent3, h as h2, ref as ref4, watchEffect as watchEffect2 } from "vue";
var reorderItemsLabels2 = ["members", "settings"];
var _OrganizationProfile = defineComponent3((props, { slots }) => {
  var _a;
  const clerk = useClerk();
  const el = ref4(null);
  const defaultSlotTeleportMap = ref4(/* @__PURE__ */ new Map());
  const labelIconSlotTeleportMap = ref4(/* @__PURE__ */ new Map());
  const customPagesSlots = (_a = slots.default) == null ? void 0 : _a.call(slots);
  const customPageNodes = computed11(() => {
    var _a2;
    return (_a2 = customPagesSlots == null ? void 0 : customPagesSlots.map((item) => {
      var _a3, _b, _c;
      let customPage = {
        label: (_b = (_a3 = item.props) == null ? void 0 : _a3.label) != null ? _b : ""
      };
      const isExternalLink = !((_c = item.children) == null ? void 0 : _c.default);
      const isReorderItem = reorderItemsLabels2.includes(item.props.label);
      if (!isReorderItem) {
        if (isExternalLink) {
          customPage = {
            ...customPage,
            url: item.props.url,
            mountIcon(el2) {
              labelIconSlotTeleportMap.value.set(item, el2);
            },
            unmountIcon: () => {
            }
          };
        } else {
          customPage = {
            ...customPage,
            url: item.props.url,
            mountIcon(el2) {
              labelIconSlotTeleportMap.value.set(item, el2);
            },
            unmountIcon: () => {
            },
            mount(el2) {
              defaultSlotTeleportMap.value.set(item, el2);
            },
            unmount: () => {
            }
          };
        }
      }
      return customPage;
    })) != null ? _a2 : [];
  });
  watchEffect2((onInvalidate) => {
    if (el.value) {
      clerk.mountOrganizationProfile(el.value, {
        ...props,
        customPages: customPageNodes.value
      });
    }
    onInvalidate(() => {
      if (el.value)
        clerk.unmountOrganizationProfile(el.value);
    });
  });
  return () => h2(ClerkLoaded, () => {
    var _a2;
    return [
      h2("div", { ref: el }),
      ...(_a2 = customPagesSlots == null ? void 0 : customPagesSlots.map((item) => {
        var _a3, _b, _c, _d, _e;
        const defaultElement = defaultSlotTeleportMap.value.get(item);
        const labelIconElement = labelIconSlotTeleportMap.value.get(item);
        return [
          labelIconElement ? h2(Teleport2, { to: labelIconElement }, (_b = (_a3 = item.children) == null ? void 0 : _a3.labelIcon) == null ? void 0 : _b.call(_a3)) : null,
          defaultElement && ((_c = item.children) == null ? void 0 : _c.default) ? h2(Teleport2, { to: defaultElement }, (_e = (_d = item.children) == null ? void 0 : _d.default) == null ? void 0 : _e.call(_d)) : null
        ];
      })) != null ? _a2 : []
    ];
  });
});
Object.defineProperty(_OrganizationProfile, "props", {
  value: ["path", "routing", "afterLeaveOrganizationUrl", "appearance"]
});
var OrganizationProfilePage = defineComponent3({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false
    }
  },
  setup(_props, { slots }) {
    return () => {
      var _a, _b;
      return [
        (_a = slots.default) == null ? void 0 : _a.call(slots),
        (_b = slots.labelIcon) == null ? void 0 : _b.call(slots)
      ];
    };
  }
});
var OrganizationProfileLink = defineComponent3({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  setup(_props, { slots }) {
    return () => {
      var _a;
      return (_a = slots.default) == null ? void 0 : _a.call(slots);
    };
  }
});
var OrganizationProfile = Object.assign(_OrganizationProfile, { Page: OrganizationProfilePage, Link: OrganizationProfileLink });

// src/components/UserProfile.ts
import { Teleport as Teleport3, computed as computed12, defineComponent as defineComponent4, h as h3, ref as ref5, watchEffect as watchEffect3 } from "vue";
var reorderItemsLabels3 = ["account", "security"];
var _UserProfile = defineComponent4((props, { slots }) => {
  var _a;
  const clerk = useClerk();
  const el = ref5(null);
  const defaultSlotTeleportMap = ref5(/* @__PURE__ */ new Map());
  const labelIconSlotTeleportMap = ref5(/* @__PURE__ */ new Map());
  const customPagesSlots = (_a = slots.default) == null ? void 0 : _a.call(slots);
  const customPageNodes = computed12(() => {
    var _a2;
    return (_a2 = customPagesSlots == null ? void 0 : customPagesSlots.map((item) => {
      var _a3, _b, _c;
      let customPage = {
        label: (_b = (_a3 = item.props) == null ? void 0 : _a3.label) != null ? _b : ""
      };
      const isExternalLink = !((_c = item.children) == null ? void 0 : _c.default);
      const isReorderItem = reorderItemsLabels3.includes(item.props.label);
      if (!isReorderItem) {
        if (isExternalLink) {
          customPage = {
            ...customPage,
            url: item.props.url,
            mountIcon(el2) {
              labelIconSlotTeleportMap.value.set(item, el2);
            },
            unmountIcon: () => {
            }
          };
        } else {
          customPage = {
            ...customPage,
            url: item.props.url,
            mountIcon(el2) {
              labelIconSlotTeleportMap.value.set(item, el2);
            },
            unmountIcon: () => {
            },
            mount(el2) {
              defaultSlotTeleportMap.value.set(item, el2);
            },
            unmount: () => {
            }
          };
        }
      }
      return customPage;
    })) != null ? _a2 : [];
  });
  watchEffect3((onInvalidate) => {
    if (el.value) {
      clerk.mountUserProfile(el.value, {
        ...props,
        customPages: customPageNodes.value
      });
    }
    onInvalidate(() => {
      if (el.value)
        clerk.unmountUserProfile(el.value);
    });
  });
  return () => h3(ClerkLoaded, () => {
    var _a2;
    return [
      h3("div", { ref: el }),
      ...(_a2 = customPagesSlots == null ? void 0 : customPagesSlots.map((item) => {
        var _a3, _b, _c, _d, _e;
        const defaultElement = defaultSlotTeleportMap.value.get(item);
        const labelIconElement = labelIconSlotTeleportMap.value.get(item);
        return [
          labelIconElement ? h3(Teleport3, { to: labelIconElement }, (_b = (_a3 = item.children) == null ? void 0 : _a3.labelIcon) == null ? void 0 : _b.call(_a3)) : null,
          defaultElement && ((_c = item.children) == null ? void 0 : _c.default) ? h3(Teleport3, { to: defaultElement }, (_e = (_d = item.children) == null ? void 0 : _d.default) == null ? void 0 : _e.call(_d)) : null
        ];
      })) != null ? _a2 : []
    ];
  });
});
Object.defineProperty(_UserProfile, "props", {
  value: ["path", "routing", "appearance", "additionalOAuthScopes", "__experimental_startPath"]
});
var UserProfilePage = defineComponent4({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: false
    }
  },
  setup(_props, { slots }) {
    return () => {
      var _a, _b;
      return [
        (_a = slots.default) == null ? void 0 : _a.call(slots),
        (_b = slots.labelIcon) == null ? void 0 : _b.call(slots)
      ];
    };
  }
});
var UserProfileLink = defineComponent4({
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  setup(_props, { slots }) {
    return () => {
      var _a;
      return (_a = slots.default) == null ? void 0 : _a.call(slots);
    };
  }
});
var UserProfile = Object.assign(_UserProfile, { Page: UserProfilePage, Link: UserProfileLink });

// src/components/uiComponents.ts
var UIPortal = defineComponent5((props) => {
  const el = ref6(null);
  watchEffect4((onInvalidate) => {
    if (el.value)
      props.mount(el.value, props.props || {});
    onInvalidate(() => {
      if (el.value)
        props.unmount(el.value);
    });
  });
  return () => h4(ClerkLoaded, () => h4("div", { ref: el }));
});
Object.defineProperty(UIPortal, "props", {
  value: ["mount", "unmount", "props"]
});
var GoogleOneTap = defineComponent5((props) => {
  const clerk = useClerk();
  return () => h4(UIPortal, {
    mount: () => clerk.openGoogleOneTap(props),
    unmount: clerk.closeGoogleOneTap
  });
});
Object.defineProperty(GoogleOneTap, "props", {
  value: ["signInForceRedirectUrl", "signUpForceRedirectUrl", "cancelOnTapOutside", "itpSupport", "fedCmSupport", "appearance"]
});
var SignIn = defineComponent5((props) => {
  const clerk = useClerk();
  return () => h4(UIPortal, {
    mount: clerk.mountSignIn,
    unmount: clerk.unmountSignIn,
    props
  });
});
Object.defineProperty(SignIn, "props", {
  value: ["path", "routing", "forceRedirectUrl", "fallbackRedirectUrl", "signUpUrl", "appearance", "initialValues", "transferable", "signUpForceRedirectUrl", "signUpFallbackRedirectUrl", "afterSignInUrl", "afterSignUpUrl", "redirectUrl", "afterSignOutUrl"]
});
var SignUp = defineComponent5((props) => {
  const clerk = useClerk();
  return () => h4(UIPortal, {
    mount: clerk.mountSignUp,
    unmount: clerk.unmountSignUp,
    props
  });
});
Object.defineProperty(SignUp, "props", {
  value: ["path", "routing", "forceRedirectUrl", "fallbackRedirectUrl", "signInUrl", "appearance", "unsafeMetadata", "initialValues", "signInFallbackRedirectUrl", "signInForceRedirectUrl", "afterSignInUrl", "afterSignUpUrl", "redirectUrl", "afterSignOutUrl"]
});
var CreateOrganization = defineComponent5((props) => {
  const clerk = useClerk();
  return () => h4(UIPortal, {
    mount: clerk.mountCreateOrganization,
    unmount: clerk.unmountCreateOrganization,
    props
  });
});
Object.defineProperty(CreateOrganization, "props", {
  value: ["path", "routing", "afterCreateOrganizationUrl", "skipInvitationScreen", "appearance", "hideSlug"]
});
var OrganizationSwitcher = defineComponent5((props) => {
  const clerk = useClerk();
  return () => h4(UIPortal, {
    mount: clerk.mountOrganizationSwitcher,
    unmount: clerk.unmountOrganizationSwitcher,
    props
  });
});
Object.defineProperty(OrganizationSwitcher, "props", {
  value: ["createOrganizationUrl", "createOrganizationMode", "organizationProfileUrl", "organizationProfileMode", "defaultOpen", "hidePersonal", "afterSwitchOrganizationUrl", "afterCreateOrganizationUrl", "afterSelectOrganizationUrl", "afterSelectPersonalUrl", "afterLeaveOrganizationUrl", "skipInvitationScreen", "hideSlug", "appearance", "organizationProfileProps"]
});
var OrganizationList = defineComponent5((props) => {
  const clerk = useClerk();
  return () => h4(UIPortal, {
    mount: clerk.mountOrganizationList,
    unmount: clerk.unmountOrganizationList,
    props
  });
});
Object.defineProperty(OrganizationList, "props", {
  value: ["afterCreateOrganizationUrl", "afterSelectOrganizationUrl", "appearance", "skipInvitationScreen", "hidePersonal", "afterSelectPersonalUrl", "hideSlug"]
});

// src/index.ts
setClerkJsLoadingErrorPackageName("vue-clerk");
export {
  AuthenticateWithRedirectCallback,
  ClerkLoaded,
  ClerkLoading,
  CreateOrganization,
  GoogleOneTap,
  OrganizationList,
  OrganizationProfile,
  OrganizationSwitcher,
  Protect,
  RedirectToCreateOrganization,
  RedirectToOrganizationProfile,
  RedirectToSignIn,
  RedirectToSignUp,
  RedirectToUserProfile,
  SignIn,
  SignInButton_default as SignInButton,
  SignInWithMetamaskButton_default as SignInWithMetamaskButton,
  SignOutButton_default as SignOutButton,
  SignUp,
  SignUpButton_default as SignUpButton,
  SignedIn,
  SignedOut,
  UserButton,
  UserProfile,
  VueClerkInjectionKey,
  WithClerk_default as WithClerk,
  WithSession_default as WithSession,
  WithUser_default as WithUser,
  clerkPlugin,
  provideClerkToVueApp,
  updateClerkOptions,
  useAuth,
  useClerk,
  useClerkProvider,
  useOrganization,
  useSession,
  useSessionList,
  useSignIn,
  useSignUp,
  useUser
};
/*!
 * Original code by Clerk, Inc.
 * MIT Licensed, Copyright 2022 Clerk, Inc., see https://github.com/clerk/javascript/blob/main/packages/react/LICENSE for details
 *
 * Credits to the Clerk team:
 * https://github.com/clerk/javascript/blob/main/packages/react/src/utils/isConstructor.ts
 */
/*!
 * Original code by Clerk, Inc.
 * MIT Licensed, Copyright 2022 Clerk, Inc., see https://github.com/clerk/javascript/blob/main/packages/react/LICENSE for details
 *
 * Credits to the Clerk team:
 * https://github.com/clerk/javascript/blob/main/packages/react/src/isomorphicClerk.ts
 */
